import { Link } from '@tanstack/react-router';

type Crumb = { id: string; name: string; slug: string };

export function CategoryBreadcrumbs({ chain }: { chain: Crumb[] }) {
  return (
    <div className="about-author-content pt-3">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">الرئيسية</Link>
          </li>
          {chain.map((c, i) => {
            const last = i === chain.length - 1;
            return (
              <li
                key={c.id}
                className={`breadcrumb-item${last ? ' active' : ''}`}
                aria-current={last ? 'page' : undefined}
              >
                {last ? (
                  c.name
                ) : (
                  <Link to="/category/$" params={{ _splat: c.slug }} search={{ page: undefined }}>
                    {c.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}
